<div class="pb-3">
    <app-card [showHeader]="false">
        <ng-template #content>
            <p-tabs [value]="selectedTab" (valueChange)="selectedTab = $event">
                <p-tablist>
                    <p-tab value="procedures">{{ 'procedures.label' | translate }}</p-tab>
                    <p-tab value="history">{{ 'procedures.history' | translate }}</p-tab>
                </p-tablist>

                <p-tabpanels>
                    <p-tabpanel value="procedures">
                        <div class="flex flex-column gap p-2">
                            <div class="infogrid gap-large align-items-center">
                                <div>{{ 'code' | translateField:prefix }}</div>
                                <div class="flex flex-row gap-large align-items-center">
                                    <div>{{ store.procedure()?.code || '' }}</div>
                                    <app-text-input [form]="form" id="customCode" [prefix]="prefix"></app-text-input>
                                </div>

                                <div>{{ 'name' | translateField:prefix }}</div>
                                <div class="flex flex-row gap-large align-items-center">
                                    <div>{{ store.procedure()?.procedure?.description || '' }}</div>
                                    <app-text-input style="min-width: 20rem;" [form]="form" id="customName"
                                        [prefix]="prefix"></app-text-input>
                                </div>

                                <div>{{ 'expertiseCode' | translateField:prefix }}</div>
                                <div>{{ store.procedure()?.procedure?.expertiseCode || '' }}</div>

                                <div>{{ 'paymentCategory' | translateField:prefix }}</div>
                                <div>{{ store.procedure()?.procedure?.paymentCategory || '' }}</div>

                                <div>{{ 'duration' | translateField:prefix }}</div>
                                <div>{{ store.procedure()?.procedure?.duration || '' }}</div>

                                <div>{{ 'limitationOfPaymentByLocation' | translateField:prefix }}</div>
                                <div>{{ store.procedure()?.procedure?.limitationOfPaymentByLocation || '' }}</div>

                                <div>{{ 'limitationOfPaymentByFrequency' | translateField:prefix }}</div>
                                <div>{{ store.procedure()?.procedure?.limitationOfPaymentByFrequency || '' }}</div>

                                <div>{{ 'pointsDirect' | translateField:prefix }}</div>
                                <div>{{ store.procedure()?.procedure?.pointsDirect || '' }}</div>

                                <div>{{ 'pointsPersonal' | translateField:prefix }}</div>
                                <div>{{ store.procedure()?.procedure?.pointsPersonal || '' }}</div>

                                <div>{{ 'pointsOverhead' | translateField:prefix }}</div>
                                <div>{{ store.procedure()?.procedure?.pointsOverhead || '' }}</div>

                                <div>{{ 'points' | translateField:prefix }}</div>
                                <div>{{ store.procedure()?.procedure?.points || '' }}</div>

                                <!-- last revision is not in our dataset imports -->
                                <!-- <div>{{ 'lastRevision' | translateField:prefix }}</div>
                                <div>{{ store.procedure()?.procedure?.lastRevision || '' | localDate }}</div> -->

                                <div>{{ 'explanation' | translateField:prefix }}</div>
                                <div>{{ store.procedure()?.procedure?.explanation || '' }}</div>

                                <div>{{ 'procedureStartsWith' | translateField:prefix }}</div>
                                <div>{{ store.procedure()?.procedure?.procedureStartsWith || '' }}</div>

                                <div>{{ 'procedureContentAndScope' | translateField:prefix }}</div>
                                <div>{{ store.procedure()?.procedure?.procedureContentAndScope || '' }}</div>

                                <div>{{ 'procedureEndsWith' | translateField:prefix }}</div>
                                <div>{{ store.procedure()?.procedure?.procedureEndsWith || '' }}</div>
                            </div>

                            <app-text-input [form]="form" id="frequency" [prefix]="prefix"></app-text-input>
                            @if (store.schedulerSettings().useCard) {
                                <app-number-input
                                    [form]="form"
                                    id="executionTolerance"
                                    [prefix]="prefix"
                                    [showHelpText]="true"
                                    [clear]="true"
                                    [min]="0"
                                ></app-number-input>
                            }

                            <div class="grid-2col gap">
                                <app-input-wysiwyg
                                    [form]="form"
                                    id="textTemplate"
                                    [placeholder]="prefix + 'fields.textTemplate'"
                                    editorKey="ServicesProceduresDetailText"
                                    [height]="300"
                                ></app-input-wysiwyg>
                                <app-input-wysiwyg
                                    [form]="form"
                                    id="courseDescription"
                                    [placeholder]="prefix + 'fields.courseDescription'"
                                    editorKey="ServicesProceduresDetailCourse"
                                    [height]="300"
                                ></app-input-wysiwyg>
                            </div>

                            <app-color-input [form]="form"></app-color-input>
                        </div>
                    </p-tabpanel>
                    <p-tabpanel value="history">
                        <app-table
                            [translatePrefix]="prefix"
                            [hideCheckboxes]="true"
                            [refreshCallback]="store.api.getMedicalProcedureHistory"
                            [refreshCallbackFragment]="getHistoryFrag"
                            [gridData]="$any(store.data.getMedicalProcedureHistory())"
                            [columns]="historyColumns"
                            [additionalFilter]="additionalFilter()"
                            [showClearFilter]="false"
                            [defaultSorters]="[{ column: 'version', direction: 'DESC' }]"
                        >
                        </app-table>
                    </p-tabpanel>
                </p-tabpanels>
            </p-tabs>
        </ng-template>

        @if (selectedTab === 'procedures') {
            <ng-template #footer>
                <app-action-buttons
                    [primaryButtonDisability]="form.untouched"
                    (primaryClickEvent)="submit()"
                    secondaryButtonType="return"
                ></app-action-buttons>
            </ng-template>
        }
    </app-card>
</div>
